import { WorkerStore } from 'accountant/worker/src/store';
import { REGISTRATION_STATUS } from '../../workerConstants';

export function hasContractInfoDraft() {
  return !!WorkerStore.worker?.contractInfo;
}

export function hasContractInfo(workerBasicInfo) {
  const { statusInfo } = workerBasicInfo;

  return REGISTRATION_STATUS[statusInfo].step >= REGISTRATION_STATUS.HAS_CONTRACT_INFO.step;
}
